import gql from 'graphql-tag';

export const CREATE_PURCHASE_ORDER_ITEM = gql`
    mutation createPurchaseOrderItemMutation ($input: CreatePurchaseOrderItemInput!) {
        createPurchaseOrderItem(input: $input) {
            id
        }
    }
`;
